import {
  COURT,
  ADDCOURT,
  ADDLOCNUMBER,
  LOCNUMBER,
  LOCTYPE,
  ADDLOCTYPE,
  ADDTYPEDAWA,
  TYPEDAWA,
  ADD_TAGADEDEFREE,
  TAKADEDEGREE,
  UPDATECOURT,
  DELETECOURT,
  UPDATETYPEDAWA,
  DELETETYPEDAWA,
  UPDATETAKADEDEGREE,
  DELETETAKADEDEGREE,
  UPDATELOCNUMBER,
  DELETELOCNUMBER,
  UPDATELOCTYPE,
  DELETELOCTYPE,
} from "../type";
import { InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const AddCourtAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Court`, data);
    dispatch({
      type: ADDCOURT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADDCOURT,
      payload: "Error" + e,
    });
  }
};
export const GetCourtAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Court`);
    dispatch({
      type: COURT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: COURT,
      payload: "Error" + e,
    });
  }
};
export const UpdateCourtAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Court`, body);
    dispatch({
      type: UPDATECOURT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATECOURT,
      payload: "Error" + e,
    });
  }
};
export const DeleteCourtAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Court?id=${id}`);
    dispatch({
      type: DELETECOURT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETECOURT,
      payload: "Error" + e,
    });
  }
};
export const AddLocnumberAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Court/CreateLocationNumber`, data);
    dispatch({
      type: ADDLOCNUMBER,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADDLOCNUMBER,
      payload: "Error" + e,
    });
  }
};
export const GetLocnumberAction = (query) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/Court/GetLocationNumbers?${query}`
    );
    dispatch({
      type: LOCNUMBER,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: LOCNUMBER,
      payload: "Error" + e,
    });
  }
};
export const UpdateLocnumberAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/Court/UpdateLocationNumber`,
      body
    );
    dispatch({
      type: UPDATELOCNUMBER,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATELOCNUMBER,
      payload: "Error" + e,
    });
  }
};
export const DeleteLocnumberAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(
      `/api/Court/DeleteLocationNumber?id=${id}`
    );
    dispatch({
      type: DELETELOCNUMBER,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETELOCNUMBER,
      payload: "Error" + e,
    });
  }
};
export const AddLocTypeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Court/CreateLocationType`, data);
    dispatch({
      type: ADDLOCTYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADDLOCTYPE,
      payload: "Error" + e,
    });
  }
};
export const GetLocTypeAction = (id) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/Court/GetLocationTypes?${id ? `courtId=${id}` : null}`
    );
    dispatch({
      type: LOCTYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: LOCTYPE,
      payload: "Error" + e,
    });
  }
};
export const UpdateLocTypeAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Court/UpdateLocationType`, body);
    dispatch({
      type: UPDATELOCTYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATELOCTYPE,
      payload: "Error" + e,
    });
  }
};
export const DeleteLocTypeAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Court/DeleteLocationType?id=${id}`);
    dispatch({
      type: DELETELOCTYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETELOCTYPE,
      payload: "Error" + e,
    });
  }
};
export const AddTypedawaAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/LawSuitForm`, data);
    dispatch({
      type: ADDTYPEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADDTYPEDAWA,
      payload: "Error" + e,
    });
  }
};
export const GetTypedawaAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/LawSuitForm`);
    dispatch({
      type: TYPEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: TYPEDAWA,
      payload: "Error" + e,
    });
  }
};
export const UpdateTypedawaAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/LawSuitForm`, body);
    dispatch({
      type: UPDATETYPEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATETYPEDAWA,
      payload: "Error" + e,
    });
  }
};
export const DeleteTypedawaAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/LawSuitForm?id=${id}`);
    dispatch({
      type: DELETETYPEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETETYPEDAWA,
      payload: "Error" + e,
    });
  }
};
export const AddTakadeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/LevelOfLawSuit`, data);
    dispatch({
      type: ADD_TAGADEDEFREE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_TAGADEDEFREE,
      payload: "Error" + e,
    });
  }
};
export const GetTakadeAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/LevelOfLawSuit`);
    dispatch({
      type: TAKADEDEGREE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: TAKADEDEGREE,
      payload: "Error" + e,
    });
  }
};
export const UpdateTakadedegAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/LevelOfLawSuit`, body);
    dispatch({
      type: UPDATETAKADEDEGREE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATETAKADEDEGREE,
      payload: "Error" + e,
    });
  }
};
export const DeleteTakadedegAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/LevelOfLawSuit?id=${id}`);
    dispatch({
      type: DELETETAKADEDEGREE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETETAKADEDEGREE,
      payload: "Error" + e,
    });
  }
};
